module.exports = __webpack_public_path__ + "static/media/multiple-choice-image-flora.82423f14.svg";